import { createSelector } from '@/shared/lib/helpers/create-store-logic';

export const [useIsValidCreateHistogramForm] = createSelector((state) => {
	const errors = Object.values(state.createHistogramForm?.validationError ?? {});

	if (errors.length !== 3) {
		return false;
	}

	return errors.every((value) => !value);
});
